import { SortDirection, SortField } from '../types'

/**
 * Returns the natural default sort direction for a given sort field.
 *
 * - `name`         → ascending  (A → Z)
 * - `score`        → descending (highest first)
 * - `audience_size`→ descending (largest first)
 * - anything else  → descending (safe default for numeric metrics)
 */
export function getDefaultSortDirection(field: SortField): SortDirection {
  if (field === 'name') return 'asc'
  return 'desc'
}
